import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { fetchPendingApproval } from 'Redux/carts/actions'

const useCartsPending = () => {
  const dispatch = useDispatch()

  const data = useSelector(state => state.carts.pendingApproval)
  const isFetching = useSelector(state => state.carts.isFetchingPendingApproval)
  const filterProviders = useSelector(state => state.carts.filterProviders)
  const filterRequestNumber = useSelector(state => state.carts.filterRequestNumber)

  const isFilterActive = !!filterProviders?.length || !!filterRequestNumber

  useEffect(() => {
    dispatch(fetchPendingApproval())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterProviders, filterRequestNumber])

  return { data, isFetching, isFilterActive }
}

export default useCartsPending
